<template>
  <div class="message-setting">
    <div class="choose-options">
      <el-input
        v-model="searchInfo.intent_name"
        placeholder="请输入意图内容"
        clearable
      ></el-input>
      <el-select
        v-model="searchInfo.trigger_type"
        placeholder="请选择触发类型"
        clearable
      >
        <el-option
          v-for="item in triggerType"
          :key="item.value"
          :value="item.value"
          :label="item.label"
        ></el-option>
      </el-select>
      <el-select
        v-model="searchInfo.skip"
        placeholder="请选择跳转位置"
        clearable
      >
        <el-option
          v-for="item in jumpPosition"
          :key="item.value"
          :value="item.value"
          :label="item.label"
        ></el-option>
      </el-select>
      <el-select
        v-model="searchInfo.status"
        placeholder="请选择生效状态"
        clearable
      >
        <el-option
          v-for="item in effectStatus"
          :key="item.value"
          :value="item.value"
          :label="item.label"
        ></el-option>
      </el-select>
      <el-button type="three" @click="getLists">筛选</el-button>
      <el-button type="three" @click="resetSearchInfo">重置</el-button>
    </div>
    <el-button type="three" size="medium" @click="add">新增短信配置</el-button>
    <el-table
      :data="settingList"
      style="width: 100%"
      :header-cell-style="{ background: '#F0F3F7', color: '#39475B' }"
      :cell-style="{
        background: '#FCFDFF',
        'font-size': '14px',
        color: '#8998AC',
      }"
    >
      <el-table-column prop="id" label="模板ID" align="center">
      </el-table-column>
      <el-table-column prop="intent" label="意图内容" align="center"
        ><template slot-scope="scope">{{
          getIntentName(scope.row)
        }}</template></el-table-column
      >
      <el-table-column prop="trigger_type" label="触发类型" align="center">
        <template slot-scope="scope">{{ getTriggerType(scope.row) }}</template>
      </el-table-column>
      <el-table-column prop="skip" label="跳转位置" align="center">
        <template slot-scope="scope">{{
          getSkipType(scope.row)
        }}</template></el-table-column
      >
      <el-table-column
        prop="title"
        label="跳转页面"
        align="center"
      ></el-table-column>
      <el-table-column prop="status" label="生效状态" align="center">
        <template slot-scope="scope">{{
          getStatusType(scope.row)
        }}</template></el-table-column
      >
      <el-table-column label="操作" width="200" align="center">
        <template slot-scope="scope">
          <el-tooltip
            class="item"
            effect="dark"
            content="编辑"
            placement="bottom"
          >
            <el-button
              @click="add(scope.row)"
              type="one"
              icon="el-icon-edit"
              circle
              size="medium"
            ></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @current-change="handleCurrentChange"
      :current-page.sync="currentPage"
      :page-size="10"
      layout="total, prev, pager, next, jumper"
      :total="total"
      prev-text="上一页"
      next-text="下一页"
      v-if="total > 10"
    >
    </el-pagination>
    <el-dialog
      :close-on-click-modal="false"
      :title="titleText"
      :visible.sync="dialogVisible"
      :before-close="handleClose"
      width="800px"
    >
      <el-form
        status-icon
        label-width="100px"
        class="demo-ruleForm"
        :model="settingForm"
      >
        <el-form-item label="触发类型：">
          <el-radio-group
            v-model="settingForm.trigger_type"
            @change="handleTriggerChange"
          >
            <el-radio
              v-for="item in triggerType"
              :key="item.value"
              :label="item.value"
              >{{ item.label }}</el-radio
            >
          </el-radio-group>
        </el-form-item>
        <el-form-item label="意图内容：" v-show="settingForm.trigger_type != 2">
          <el-autocomplete
            v-model="settingForm.intent_name"
            :fetch-suggestions="querySearchAsync"
            placeholder="模糊搜索意图"
            @select="handleSelect"
          ></el-autocomplete>
        </el-form-item>
        <el-form-item label="跳转位置：">
          <el-radio-group
            v-model="settingForm.skip"
            @change="handlePositionChange"
          >
            <el-radio
              v-for="item in jumpPosition"
              :key="item.value"
              :label="item.value"
              >{{ item.label }}</el-radio
            >
          </el-radio-group>
        </el-form-item>
        <el-form-item label="跳转页面：" v-show="settingForm.skip != 3">
          <div class="url-container" v-show="settingForm.skip == 1">
            <el-input
              v-model="settingForm.title"
              placeholder="请输入页面名"
            ></el-input>
            <el-input
              placeholder="请输入跳转的官网页面地址"
              v-model="settingForm.url"
            ></el-input>
          </div>
          <el-select
            v-show="settingForm.skip == 2"
            placeholder="请选择小程序页面路径"
            v-model="settingForm.title"
            @change="handleUrlChange"
          >
            <el-option
              v-for="item in appUrls"
              :key="item.id"
              :value="item.name"
              >{{ item.name }}</el-option
            >
          </el-select>
        </el-form-item>
        <el-form-item label="生效状态：">
          <el-radio-group v-model="settingForm.status">
            <el-radio
              v-for="item in effectStatus"
              :key="item.value"
              :label="item.value"
              >{{ item.label }}</el-radio
            >
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div class="tips" v-show="settingForm.trigger_type == 2">
        存在多条触发类型为挂机时，仅最后一条生效
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" round @click="handleClose">取消</el-button>
        <el-button size="medium" round type="primary" @click="confirm"
          >提交</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import { isSuccess, isEmpty } from '@/utils/index'
  import { TRIGGER_TYPE, JUMP_POSITION, EFFECT_STATUS } from '@/utils/const'
  import { searchIntent } from '@/api/session'
  import { getSettingList, addSetting, getAppUrl } from '@/api/messageManager'
  export default {
    data() {
      return {
        settingList: [],
        titleText: '新增模板',
        isAdd: true,
        dialogVisible: false,
        searchInfo: {
          intent_name: '',
          skip: '',
          trigger_type: '',
          status: '',
        },
        settingForm: {
          trigger_type: 1,
          intent_code: '',
          intent_name: '',
          skip: 1,
          applet_id: '',
          status: 1,
          url: '',
          title: '',
        },
        triggerType: TRIGGER_TYPE,
        jumpPosition: JUMP_POSITION,
        effectStatus: EFFECT_STATUS,
        aimList: [],
        appUrls: [], //小程序跳转页面
        currentPage: 1,
        total: 0,
      }
    },
    mounted() {
      this.getLists()
      this.getAppUrl()
    },
    computed: {
      getTriggerType() {
        return (row) => {
          return this.triggerType.find((item) => item.value == row.trigger_type)
            .label
        }
      },

      getSkipType() {
        return (row) => {
          return this.jumpPosition.find((item) => item.value == row.skip).label
        }
      },
      getStatusType() {
        return (row) => {
          return this.effectStatus.find((item) => item.value == row.status)
            .label
        }
      },
      getIntentName() {
        return (row) => {
          let intentName = '-'
          if (!isEmpty(row.intent_code)) {
            intentName = row.intent_name
          }
          return intentName
        }
      },
    },
    methods: {
      async getLists() {
        const res = await getSettingList({
          page: this.currentPage,
          ...this.searchInfo,
        })
        this.total = res.data.count
        this.settingList = res.data.list
      },
      async getAppUrl() {
        const res = await getAppUrl()
        this.appUrls = res.data
      },
      async getAimList() {
        const res = await searchIntent({
          keywords: this.settingForm.intent_name,
        })

        this.aimList = res.data
      },
      add(row) {
        this.isAdd = true
        this.titleText = '新增模板'
        if (row.id) {
          this.isAdd = false
          this.titleText = '修改模板'
          this.settingForm = { ...row }
          if (!isEmpty(row.intent)) {
            this.settingForm.intent_name = row.intent_name
          }
        }
        this.dialogVisible = true
      },
      handleClose() {
        this.settingForm = {
          trigger_type: 1,
          intent_code: '',
          skip: 1,
          applet_id: '',
          status: 1,
          url: '',
          title: '',
          intent_name: '',
        }
        this.dialogVisible = false
      },
      async confirm() {
        let form = {
          trigger_type: this.settingForm.trigger_type,
          skip: this.settingForm.skip,
          status: this.settingForm.status,
          title: this.settingForm.title,
        }
        if (!this.isAdd) {
          form.id = this.settingForm.id
        }
        if (this.settingForm.trigger_type == 1) {
          form.intent_code = this.settingForm.intent_code
        }
        switch (this.settingForm.skip) {
          case 1: {
            form.url = this.settingForm.url
            break
          }
          case 2: {
            form.applet_id = this.settingForm.applet_id
            break
          }
          default:
            break
        }
        if (isEmpty(form)) {
          this.$message.error('请完善信息')
          return
        }
        const res = await addSetting(form)
        if (isSuccess(res.code)) {
          this.$message.success(`${this.isAdd ? '新增' : '修改'}成功`)
          this.handleClose()
          this.getLists()
          return
        }
      },
      resetSearchInfo() {
        this.searchInfo = {
          intent_name: '',
          skip: '',
          trigger_type: '',
          status: '',
        }
        this.getLists()
      },
      querySearchAsync(queryString, cb) {
        clearTimeout(this.timeout)
        this.timeout = setTimeout(async () => {
          if (queryString.length < 1) {
            cb([])
            return
          }
          await this.getAimList()
          let aimList = this.aimList
          let results = queryString
            ? aimList.filter((item) => item.intent_name.includes(queryString))
            : aimList
          results = results.map((item) => {
            return { ...item, value: item.intent_name }
          })
          // 调用 callback 返回建议列表的数据
          cb(results)
        }, 500 * Math.random())
      },
      handleUrlChange(e) {
        this.settingForm.applet_id = this.appUrls.find(
          (item) => item.name == e
        ).id
      },
      handleSelect(e) {
        this.settingForm.intent_code = e.intent_code
      },
      handleTriggerChange(e) {
        if (e == 2) {
          this.settingForm.intent_name = ''
          this.settingForm.intent_code = ''
        }
      },
      handlePositionChange(e) {
        switch (e) {
          case 1: {
            this.settingForm.title = ''
            this.settingForm.applet_id = ''
            break
          }
          case 2: {
            this.settingForm.title = ''
            this.settingForm.url = ''
            break
          }
          case 3: {
            this.settingForm.title = 'h5'
            this.settingForm.url = ''
            this.settingForm.applet_id = ''
            break
          }
        }
      },
      handleCurrentChange() {
        this.getLists()
      },
    },
  }
</script>

<style lang="scss">
  .message-setting {
    .el-form {
      .el-input,
      .el-select,
      .el-autocomplete {
        width: 80%;
      }
      .el-select,
      .el-autocomplete {
        .el-input {
          width: 100%;
        }
      }
    }
    .url-container {
      .el-input:first-child {
        margin-right: 10px;
        width: 20%;
      }
      .el-input:last-child {
        width: 70%;
      }
    }
  }
</style>
